// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type FeatureTypesQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.FeatureTypesFilter>;
}>;


export type FeatureTypesQuery = { __typename?: 'Query', featureTypes: Array<{ __typename?: 'FeatureType', id: string, name: string, allowedInBuilding: boolean, allowedInLevel: boolean, parent?: { __typename?: 'FeatureType', id: string, name: string, allowedInBuilding: boolean, allowedInLevel: boolean, roomTypes: Array<{ __typename?: 'RoomType', id: string, name: string }> } | null | undefined, roomTypes: Array<{ __typename?: 'RoomType', id: string, name: string }> }> };

export type FeatureTypes_RoomTypesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FeatureTypes_RoomTypesQuery = { __typename?: 'Query', roomTypes: Array<{ __typename?: 'RoomType', id: string, name: string }> };

export type SaveFeatureTypeMutationVariables = Types.Exact<{
  input: Types.SaveFeatureTypeInput;
}>;


export type SaveFeatureTypeMutation = { __typename?: 'Mutation', saveFeatureType: { __typename?: 'SaveFeatureTypeResult', featureType: { __typename?: 'FeatureType', id: string, name: string, allowedInBuilding: boolean, allowedInLevel: boolean, parent?: { __typename?: 'FeatureType', id: string, name: string, allowedInBuilding: boolean, allowedInLevel: boolean, roomTypes: Array<{ __typename?: 'RoomType', id: string, name: string }> } | null | undefined, roomTypes: Array<{ __typename?: 'RoomType', id: string, name: string }> } } };

export type DeleteFeatureTypeMutationVariables = Types.Exact<{
  input: Types.DeleteFeatureTypeInput;
}>;


export type DeleteFeatureTypeMutation = { __typename?: 'Mutation', deleteFeatureType: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export type FeatureTypeDetailsFragment = { __typename?: 'FeatureType', id: string, name: string, allowedInBuilding: boolean, allowedInLevel: boolean, parent?: { __typename?: 'FeatureType', id: string, name: string, allowedInBuilding: boolean, allowedInLevel: boolean, roomTypes: Array<{ __typename?: 'RoomType', id: string, name: string }> } | null | undefined, roomTypes: Array<{ __typename?: 'RoomType', id: string, name: string }> };

export const FeatureTypeDetailsFragmentDoc = gql`
    fragment FeatureTypeDetails on FeatureType {
  id
  name
  allowedInBuilding
  allowedInLevel
  parent {
    id
    name
    allowedInBuilding
    allowedInLevel
    roomTypes {
      id
      name
    }
  }
  roomTypes {
    id
    name
  }
}
    `;
export const FeatureTypesDocument = gql`
    query FeatureTypes($filter: FeatureTypesFilter) {
  featureTypes(filter: $filter) {
    ...FeatureTypeDetails
  }
}
    ${FeatureTypeDetailsFragmentDoc}`;

/**
 * __useFeatureTypesQuery__
 *
 * To run a query within a React component, call `useFeatureTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureTypesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFeatureTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FeatureTypesQuery, FeatureTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FeatureTypesQuery, FeatureTypesQueryVariables>(FeatureTypesDocument, options);
      }
export function useFeatureTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FeatureTypesQuery, FeatureTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FeatureTypesQuery, FeatureTypesQueryVariables>(FeatureTypesDocument, options);
        }
// @ts-ignore
export function useFeatureTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FeatureTypesQuery, FeatureTypesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FeatureTypesQuery, FeatureTypesQueryVariables>;
export function useFeatureTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FeatureTypesQuery, FeatureTypesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FeatureTypesQuery | undefined, FeatureTypesQueryVariables>;
export function useFeatureTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FeatureTypesQuery, FeatureTypesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FeatureTypesQuery, FeatureTypesQueryVariables>(FeatureTypesDocument, options);
        }
export type FeatureTypesQueryHookResult = ReturnType<typeof useFeatureTypesQuery>;
export type FeatureTypesLazyQueryHookResult = ReturnType<typeof useFeatureTypesLazyQuery>;
export type FeatureTypesSuspenseQueryHookResult = ReturnType<typeof useFeatureTypesSuspenseQuery>;
export type FeatureTypesQueryResult = ApolloReactCommon.QueryResult<FeatureTypesQuery, FeatureTypesQueryVariables>;
export const FeatureTypes_RoomTypesDocument = gql`
    query FeatureTypes_RoomTypes {
  roomTypes {
    id
    name
  }
}
    `;

/**
 * __useFeatureTypes_RoomTypesQuery__
 *
 * To run a query within a React component, call `useFeatureTypes_RoomTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureTypes_RoomTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureTypes_RoomTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeatureTypes_RoomTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FeatureTypes_RoomTypesQuery, FeatureTypes_RoomTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FeatureTypes_RoomTypesQuery, FeatureTypes_RoomTypesQueryVariables>(FeatureTypes_RoomTypesDocument, options);
      }
export function useFeatureTypes_RoomTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FeatureTypes_RoomTypesQuery, FeatureTypes_RoomTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FeatureTypes_RoomTypesQuery, FeatureTypes_RoomTypesQueryVariables>(FeatureTypes_RoomTypesDocument, options);
        }
// @ts-ignore
export function useFeatureTypes_RoomTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<FeatureTypes_RoomTypesQuery, FeatureTypes_RoomTypesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FeatureTypes_RoomTypesQuery, FeatureTypes_RoomTypesQueryVariables>;
export function useFeatureTypes_RoomTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FeatureTypes_RoomTypesQuery, FeatureTypes_RoomTypesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<FeatureTypes_RoomTypesQuery | undefined, FeatureTypes_RoomTypesQueryVariables>;
export function useFeatureTypes_RoomTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FeatureTypes_RoomTypesQuery, FeatureTypes_RoomTypesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FeatureTypes_RoomTypesQuery, FeatureTypes_RoomTypesQueryVariables>(FeatureTypes_RoomTypesDocument, options);
        }
export type FeatureTypes_RoomTypesQueryHookResult = ReturnType<typeof useFeatureTypes_RoomTypesQuery>;
export type FeatureTypes_RoomTypesLazyQueryHookResult = ReturnType<typeof useFeatureTypes_RoomTypesLazyQuery>;
export type FeatureTypes_RoomTypesSuspenseQueryHookResult = ReturnType<typeof useFeatureTypes_RoomTypesSuspenseQuery>;
export type FeatureTypes_RoomTypesQueryResult = ApolloReactCommon.QueryResult<FeatureTypes_RoomTypesQuery, FeatureTypes_RoomTypesQueryVariables>;
export const SaveFeatureTypeDocument = gql`
    mutation SaveFeatureType($input: SaveFeatureTypeInput!) {
  saveFeatureType(input: $input) {
    featureType {
      ...FeatureTypeDetails
    }
  }
}
    ${FeatureTypeDetailsFragmentDoc}`;

/**
 * __useSaveFeatureTypeMutation__
 *
 * To run a mutation, you first call `useSaveFeatureTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFeatureTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFeatureTypeMutation, { data, loading, error }] = useSaveFeatureTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveFeatureTypeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveFeatureTypeMutation, SaveFeatureTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveFeatureTypeMutation, SaveFeatureTypeMutationVariables>(SaveFeatureTypeDocument, options);
      }
export type SaveFeatureTypeMutationHookResult = ReturnType<typeof useSaveFeatureTypeMutation>;
export type SaveFeatureTypeMutationResult = ApolloReactCommon.MutationResult<SaveFeatureTypeMutation>;
export const DeleteFeatureTypeDocument = gql`
    mutation DeleteFeatureType($input: DeleteFeatureTypeInput!) {
  deleteFeatureType(input: $input) {
    emptyResult
  }
}
    `;

/**
 * __useDeleteFeatureTypeMutation__
 *
 * To run a mutation, you first call `useDeleteFeatureTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeatureTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeatureTypeMutation, { data, loading, error }] = useDeleteFeatureTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFeatureTypeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteFeatureTypeMutation, DeleteFeatureTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteFeatureTypeMutation, DeleteFeatureTypeMutationVariables>(DeleteFeatureTypeDocument, options);
      }
export type DeleteFeatureTypeMutationHookResult = ReturnType<typeof useDeleteFeatureTypeMutation>;
export type DeleteFeatureTypeMutationResult = ApolloReactCommon.MutationResult<DeleteFeatureTypeMutation>;